import React from "react";
import { bool, string, func } from "prop-types";

import { statusTagColor } from "util/cedip";
import InfoTag from "pages/echeck/components/InfoTag";
import { ResponsiveHeader, DesktopButtons, MobileButtons } from "pages/_components/header";
import Action from "pages/_components/Action";
import Button from "pages/_components/Button";

const CedipHead = ({ isDesktop, cedipNumber, status, ...props }) => {
    const { className, backLinkTo, id, handleClick } = props;

    return (
        <ResponsiveHeader
            className={className}
            id={id}
            backLinkTo={backLinkTo}
            infoComponents={
                isDesktop && (
                    <div className="pl-4">
                        <InfoTag type="info" message={status} tagBackground={statusTagColor(status)} />
                    </div>
                )
            }>
            <DesktopButtons>
                <Button
                    className="btn btn-outline"
                    image="images/download.svg"
                    label="global.download"
                    onClick={() => handleClick("pdf")}
                />
            </DesktopButtons>
            <MobileButtons>
                <Action labelKey="global.download" handleClick={() => handleClick("pdf")} />
            </MobileButtons>
        </ResponsiveHeader>
    );
};

CedipHead.propTypes = {
    cedipNumber: string.isRequired,
    status: string.isRequired,
    id: string,
    className: string,
    backLinkTo: string.isRequired,
    hasActiveSession: bool,
    isDesktop: bool,
    isMobile: bool,
    hideNavbarInMobile: bool,
    handleClick: func.isRequired,
};

CedipHead.defaultProps = {
    id: "",
    className: "",
    hasActiveSession: false,
    isDesktop: false,
    isMobile: false,
    hideNavbarInMobile: false,
};
export default CedipHead;
